import React, { Component } from 'react';
import { themr } from 'react-css-themr';
import classnames from 'classnames';

import { Menu, MenuItem } from 'common/components/core/menu';
import { Portal } from 'react-portal';
import theme from './ContextMenu.scss';

const ContextMenuFactory = ({
    MenuComponent = Menu,
    MenuItemComponent = MenuItem
}) => {
    class ContextMenu extends Component {
        handleClickOutside = event => {
            this.props.handleClickOutside(event);
        };

        getPortalRef = ref => {
            this.portalRef = ref;
            this.props.getContextMenuPortalRef?.(ref);
        };

        render() {
            const { theme, items, className, ...others } = this.props;
            var wrapStyle = {
                position: 'absolute',
                left: this.props.x,
                top: this.props.y
            };
            return (
                <Portal ref={this.getPortalRef}>
                    <div
                        style={wrapStyle}
                        className={classnames(theme.menuWrap, className)}
                    >
                        <MenuComponent theme={theme}>
                            {items.map((item, index) => {
                                return (
                                    <MenuItemComponent
                                        {...others}
                                        theme={theme}
                                        key={index}
                                        value={item.value}
                                        caption={item.value}
                                        type={item.type}
                                        testId={item.testId}
                                        onClick={item.onClick.bind(this)}
                                    />
                                );
                            })}
                        </MenuComponent>
                    </div>
                </Portal>
            );
        }
    }
    return themr('ContextMenu', theme, { withRef: true })(ContextMenu);
};

const DefaultContextMenu = ContextMenuFactory({});

export default DefaultContextMenu;

export { DefaultContextMenu as ContextMenu, ContextMenuFactory };
